import {
  COLORS,
  FONT_SIZES,
  FONT_WEIGHTS,
  tabletAndUp,
} from '@aboutyou/ui-components';
import styled, {css} from 'styled-components';
import {
  HintText,
  SubmitButton,
} from '../../Authentication/AuthenticationModal/components/FormComponents';

export const FormTitle = styled.span`
  padding: 0 0 0 6px;
  font-size: ${FONT_SIZES.px16};
  display: block;
  font-weight: ${FONT_WEIGHTS.bold};
`;

export const Container = styled.div`
  padding: 16px;
  background: ${COLORS.White};

  &:last-of-type {
    margin-top: 8px;
  }

  ${tabletAndUp(css`
    padding: 0;
    background: ${COLORS.White};
  `)}
`;

export const FormWrapper = styled.div`
  ${tabletAndUp(css`
    max-width: 539px;
    border-radius: 5px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.04),
      0 10px 15px 0 rgba(0, 0, 0, 0.04);
    border: solid 1px ${COLORS.Grey3};
    padding: 32px;
    overflow: auto;
  `)}
`;

export const DefaultForm = styled.form`
  ${tabletAndUp(css`
    ${SubmitButton} {
      width: auto;
      padding: 16px 24px;
      line-height: 16px;
    }
  `)}
`;

export const InputRow = styled.div<{$extraMargin?: boolean; $align?: boolean}>`
  margin-bottom: ${({$extraMargin}) => ($extraMargin ? 30 : 20)}px;

  ${({$align}) =>
    $align &&
    css`
      display: flex;
      align-items: center;
    `}
`;

export const GrayedText = styled(HintText)`
  font-size: ${FONT_SIZES.px14};
  line-height: 18px;
  color: ${COLORS.Grey1};
  cursor: pointer;
  margin-top: 24px;
  margin-bottom: 32px;
`;

export const SubmitButtonContainer = styled.div`
  position: sticky;
  bottom: -100%;
  justify-content: center;
  padding: 16px;
  background-color: ${COLORS.White};
  border-top: 1px solid rgb(242, 242, 242);
  // eslint-disable-next-line local-rules/css-layout-animation
  transition: bottom 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 1;

  // since its parent has a 16px padding, we have to use negative margins for fullwidth
  margin-left: -16px;
  margin-right: -16px;

  button {
    width: 100%;
    max-width: none;
    margin: 0;
  }

  ${tabletAndUp(css`
    display: flex;
    justify-content: flex-end;
    position: relative;
    bottom: auto;
    border-top: none;

    button {
      width: auto;
      margin: 0;
    }
  `)}
`;
